module.exports = __webpack_public_path__ + "img/login6.15219091.png";